import React, { useState } from "react";
import styles from "./purchaseOrderScopeOfWork.module.css";
import moment from "moment";
import { Markup } from "interweave";

export const PurchaseOrderScopeOfWork = ({ scope_of_work }) => {
  const [show, setShow] = useState(true);
  return (
    <div>
      <div className={styles.basicInfoDivPOCard}>
        <div className={styles.BasicInfoTopPOCard}>
          <div className={styles.basicInfoTopImgPOCard}>
            <div>
              <img src="./images/stratum/scopeOfWork.svg" alt="" />
            </div>
            <h6>Scope Of Work</h6>
          </div>

          <img
            src="/images/upArrow.png"
            className={!show ? styles.rotateSvg : ""}
            alt=""
            onClick={() => setShow(!show)}
          />
        </div>

        {show && (
          <>
            <div className={styles.basicInfoDetailPOCard}>
              <p><Markup content={scope_of_work} /></p>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
